var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.to,"target":_vm.target},on:{"click":function($event){$event.preventDefault();return _vm.handEve($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }